import { render, staticRenderFns } from "./AdminWorkFlowHistoryActivityComment.vue?vue&type=template&id=4949dcd0&scoped=true"
import script from "./AdminWorkFlowHistoryActivityComment.vue?vue&type=script&lang=js"
export * from "./AdminWorkFlowHistoryActivityComment.vue?vue&type=script&lang=js"
import style0 from "./AdminWorkFlowHistoryActivityComment.vue?vue&type=style&index=0&id=4949dcd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949dcd0",
  null
  
)

export default component.exports